import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import H1 from 'UIComponents/elements/headings/H1';
import FormattedName from 'I18n/components/FormattedName';
import { OLAF } from 'HubStyleTokens/colors';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
// @ts-expect-error Untyped module
import useMediaQuery from '../hooks/useMediaQuery';
import { AvatarViewer } from '../features/avatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Avatar = styled(AvatarViewer).withConfig({
  displayName: "UserProfile__Avatar",
  componentId: "sc-1e78jb0-0"
})(["border:2px solid ", ";border-radius:50%;"], OLAF);
const NameContainer = styled.div.withConfig({
  displayName: "UserProfile__NameContainer",
  componentId: "sc-1e78jb0-1"
})(["color:", ";&.narrow{margin:10px 0 0 0;text-align:center;}&.wide{margin:0 0 0 20px;text-align:left;}"], OLAF);
const NameHeading = styled(({
  className,
  firstName,
  lastName
}) => /*#__PURE__*/_jsx(H1, {
  className: className,
  "data-test-id": "user-full-name",
  children: /*#__PURE__*/_jsx(FormattedName, {
    familyName: lastName,
    givenName: firstName
  })
})).withConfig({
  displayName: "UserProfile__NameHeading",
  componentId: "sc-1e78jb0-2"
})(["margin:0;font-size:2rem;font-weight:bold;"]);
export const UserProfile = ({
  avatarHash,
  firstName,
  lastName,
  email,
  use = 'responsive'
}) => {
  const isSmallScreen = useMediaQuery(`screen and (max-width: ${GRID_BREAKPOINT_SMALL})`);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    alignSelf: "stretch",
    direction: isSmallScreen || use === 'stacked' ? 'column' : 'row',
    justify: "start",
    children: [/*#__PURE__*/_jsx(UIBox, {
      style: {
        paddingTop: '8px'
      },
      children: /*#__PURE__*/_jsx(Avatar, {
        avatarHash: avatarHash,
        email: email,
        size: "lg"
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(NameContainer, {
        className: isSmallScreen || use === 'stacked' ? 'narrow' : 'wide',
        children: /*#__PURE__*/_jsx(NameHeading, {
          firstName: firstName,
          lastName: lastName
        })
      })
    })]
  });
};
export default UserProfile;